import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RegistrosService } from '../registros.service';
import { BitacoraInformeInterface } from 'app/modules/models/bitacora-informe.model';
import { ResponseInterface } from 'app/modules/models/response.model';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'bitacora-informes',
    templateUrl: 'bitacora-informes.component.html',
    standalone: true,
    imports: [CommonModule, MatIconModule]
})

export class BitacoraInformesComponent implements OnInit {
    BitacoraInforme: BitacoraInformeInterface[] = [];
    descargandoInforme = false;

    constructor(
        private _registrosService: RegistrosService
    ) { }

    ngOnInit() {
        this.bitacoraInfome();
    }

    bitacoraInfome(){
        this._registrosService.getBitacoraInfome()
            .then((response: ResponseInterface)=>{
                this.BitacoraInforme= response.data as BitacoraInformeInterface []
            })
    }

    descargarInforme(informe: BitacoraInformeInterface): void {
        this.descargandoInforme = true;
        try {
            if (!informe?.urlDocumento) {
                console.error('El informe seleccionado no contiene URL para descargar.');
                return;
            }

            window.open(informe.urlDocumento, '_blank');
        } finally {
            this.descargandoInforme = false;
        }
    }
}
